<template>
  <div class="fund-list" :class="{'fund-list-mobile' : isMobile == 'mobile'}">
    <div v-for="(item,index) in newsList" :key="item.id">
      <listCard :position="index%2>0?'right':'left'" :item="item"></listCard>
    </div>
  </div>
</template>

<script>
import listCard from './componets/listCard.vue'
import { listSpecFund } from '@/api/index';
export default {
  name:'specialFund',
  components: {
    listCard
  },
  computed: {
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  data() {
    return {
      newsList: [],
    };
  },
  mounted() {
    this.listSpecFunds()
  },
  methods: {
    async listSpecFunds(moduleId, page, size, title) {
      let res = await listSpecFund({
        "type": 2,
        "page": page || 1,
        "size": size || 100
      })
      if (res.data && res.data != null) {
        this.newsList = res.data.records
      }
    },
  },
};
</script>

<style scoped lang="less">

.fund-list{
  padding: 2rem 4rem;
  background: #FFFFFF;
  box-sizing: border-box;
}
.fund-list-mobile{
  padding: 1rem 18px!important;
}
</style>